.sn-hero-header-type-1 {
  .me-heading {
    @include desktop {
      margin-top: map-get($map: $spacings, $key: 4xl);
    }
  }

  @include below($breakpoint-desktop-md) {
    me-column:first-child {
      text-align: center;
    }

    .me-list.me-list--inline.me-list--icon {
      justify-content: center;
    }

    .hero-header-type-1__actions-group {
      justify-content: center;
    }
  }
}

.sn-hero-header-type-1__media {
  width: 100%;
  aspect-ratio: 1.2;

  .picture {
    overflow: visible;

    img {
      width: auto;
    }
  }

   @include above($media-desktop) {
    margin-top: -#{map-get($map: $spacings, $key: 4xl)};
    margin-right: -#{map-get($map: $spacings, $key: 4xl)};
    margin-left: auto;
  }

  @include below($breakpoint-desktop-md) {
    display: none;
  }
}
